export const publicTemplateThumbnails = ['beach.jpg', 'deer_day.jpg', 'deer_night.jpg', 'flowers.png', 'iceland.png', 'night.jpg', 'sea.jpg', 'times-square.jpg']

export const publicForegroundImages = {
  b0bf584920cc45aea6d7c19da5d90983: 'img/foreground/finnish-breakfast.jpg',
  '71d2f0f48a5d4b26a230ee695f03cf9e': 'img/foreground/pill-bottle.jpg'
}
export const baseURL = 'https://api.kenban.co.uk'
export const baseURLWS = 'wss://api.kenban.co.uk'
export const stripePurchaseLink = 'https://buy.stripe.com/test_28o2bc4Iib4o8jSfYZ'
